export default "__VITE_ASSET__COEcO2rc__"